module.exports = __webpack_public_path__ + "static/media/Sweets.9262ac24.svg";